import React from 'react'
import styled from "styled-components";

// const SpinnerWrapper = styled.div`
//     position: absolute;
//     width: 100%;
//     height: 100%;
//     top: 0;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     background-color: rgba(000,000,000,0.6);`;

const SpinnerWrapper = styled.div`
   `;

const myStyle = {
    width: 100,
    height: 100,
    color: "darkblue"

} as React.CSSProperties

export default (props: any) => {
    return (props.show && <SpinnerWrapper>
        <div className="spinner-grow" style={myStyle}></div>
    </SpinnerWrapper>)
}
// magic
